import { render, staticRenderFns } from "./serviceaccount.vue?vue&type=template&id=b90d4c7e&scoped=true"
import script from "./serviceaccount.vue?vue&type=script&lang=js"
export * from "./serviceaccount.vue?vue&type=script&lang=js"
import style0 from "./serviceaccount.vue?vue&type=style&index=0&id=b90d4c7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90d4c7e",
  null
  
)

export default component.exports